import {EnvironmentConfig} from '@src/environments/EnvironmentConfig';
import {EnvironmentNames} from '@src/environments/environments.name';
import {AuthService} from '@src/auth/auth.service';

export const environment: EnvironmentConfig = {
  authServiceType: AuthService,
  clientName: 'oris',
  envName: EnvironmentNames.qaaws,
  siteKey: '6LelNhAbAAAAAMW6SsL08K3JonExZhfJvfFCYB9C',
  authConfig: {
    // Url of the Identity Provider
    issuer: 'https://orisqa-auth.was.testorisqa.dentsutracking.com',
    loginUrl: 'https://orisqa-auth.was.testorisqa.dentsutracking.com/authorize',
    postLogoutRedirectUri: 'https://orisqa.was.testorisqa.dentsutracking.com',
    // URL of the SPA to redirect the user to after login
    redirectUri: 'https://orisqa.was.testorisqa.dentsutracking.com/login',
    silentRefreshRedirectUri: 'https://orisqa.was.testorisqa.dentsutracking.com/silent-refresh.html',
    // The SPA's id. The SPA is registerd with this id at the auth-server
    clientId: 'WAS_SPA',
    responseType: 'token',
    // set the scope for the permissions the client should request
    // The first three are defined by OIDC. The 4th is a usecase-specific one
    scope: 'openid profile was roles email',
    oidc: true,
    showDebugInformation: false
  },
  apiBaseUrl: 'https://orisqa-api.was.testorisqa.dentsutracking.com',
  mapBox: {
    appKey: 'pk.eyJ1IjoiZGVubmlzY2FycmVpcmEiLCJhIjoiY2plemh5bWlqMGJyajMzcGRrODJ0MTlkZCJ9.jaEGWDdTSALHzEoJsMszyQ'
  }
};
